import React, { Dispatch, SetStateAction, useCallback, useEffect } from 'react';

import useEmblaCarousel from 'embla-carousel-react';

import { Thumb } from '../GalleryComponent';
import { NextButton, PrevButton, usePrevNextButtons } from './EmblaCarouselArrowButtons';

interface Props {
  selectedIndex: number;
  slides: number[];
  setSelectedIndex: Dispatch<SetStateAction<number>>;
  imageUrls: string[];
}
import './embla.css';

export const CarouselContainer = ({
  slides,
  setSelectedIndex,
  imageUrls,
  selectedIndex,
}: Props) => {
  const options = { loop: true };

  const [emblaMainRef, emblaMainApi] = useEmblaCarousel(options);
  const [emblaThumbsRef, emblaThumbsApi] = useEmblaCarousel({
    containScroll: 'keepSnaps',
    dragFree: true,
  });

  const onThumbClick = useCallback(
    (index: number) => {
      if (!emblaMainApi || !emblaThumbsApi) return;
      emblaMainApi.scrollTo(index);
    },
    [emblaMainApi, emblaThumbsApi],
  );

  const onSelect = useCallback(() => {
    if (!emblaMainApi || !emblaThumbsApi) return;
    setSelectedIndex(emblaMainApi.selectedScrollSnap());
    emblaThumbsApi.scrollTo(emblaMainApi.selectedScrollSnap());
  }, [emblaMainApi, emblaThumbsApi, setSelectedIndex]);

  useEffect(() => {
    if (!emblaMainApi) return;
    onSelect();

    emblaMainApi.on('select', onSelect).on('reInit', onSelect);
  }, [emblaMainApi, onSelect]);

  const { prevBtnDisabled, nextBtnDisabled, onPrevButtonClick, onNextButtonClick } =
    usePrevNextButtons(emblaMainApi);

  return (
    <div className="relative">
      <div className="embla">
        <div className="embla__viewport" ref={emblaMainRef}>
          <div className="embla__container">
            {slides.map((index) => (
              <div className="embla__slide" key={index}>
                <div className="embla__slide__number">
                  <img src={imageUrls[index]} alt="" className="h-full w-full object-contain" />
                </div>
              </div>
            ))}
          </div>
        </div>
        <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
        <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />

        <div className="absolute bottom-0 left-0 right-0 z-10">
          <div className="embla-thumbs">
            <div className="embla-thumbs__viewport" ref={emblaThumbsRef}>
              <div className="embla-thumbs__container ">
                {slides.map((index) => (
                  <Thumb
                    key={index}
                    onClick={() => onThumbClick(index)}
                    selected={index === selectedIndex}
                    index={index}
                    src={imageUrls[index]}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
